export default "__VITE_ASSET__D9VBe$fW__"